import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
const NoTasksMatchFiltersEmptyState = () => /*#__PURE__*/_jsx(UIEmptyState, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasks-table.emptyStates.noTasksMatchFilters.title"
  }),
  primaryContent: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "tasks-table.emptyStates.noTasksMatchFilters.message"
  }),
  secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
    name: "empty-state-charts",
    height: "100%"
  }),
  "data-selenium-test": "tasks-table-no-tasks-match-filters-empty-state"
});
export default NoTasksMatchFiltersEmptyState;